import { useCallback, useState } from 'react';
import Button from "@ergeon/core-components/exports/Button.ts";
import { EVENTS, gtag } from '@/lib/gtag';
import { ComputerDesktopIcon } from "@heroicons/react/24/outline";
import ScreenShareManager from './ScreenShareManager';

export default function ButtonScreenShare() {
  const [shareSessionId, setShareSessionId] = useState<number | null>(null);
  const isScreenShareEnabled = shareSessionId !== null;

  const handleToggleScreenShare = useCallback(() => {
    console.log('share screen button clicked.');
    
    if (isScreenShareEnabled) {
      // Stop current session
      setShareSessionId(null);
    } else {
      // Start new session with unique ID
      setShareSessionId(Date.now());
    }
    
    gtag(EVENTS.SCREEN_SHARE);
  }, [isScreenShareEnabled]);

  return (
    <>
      <Button
        flavor="regular"
        isActive={isScreenShareEnabled}
        isSquare
        onClick={handleToggleScreenShare}
        size="large"
        title="Share screen">
        <ComputerDesktopIcon className="size-6" />
      </Button>

      {shareSessionId && (
        <ScreenShareManager
          key={shareSessionId}
          onStop={() => setShareSessionId(null)}
        />
      )}
    </>
  );
}
